/* eslint-disable complexity */

import './index.scss';
import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledInput from '../../../claim/shared/components/claim-fields/labeled-input';
import RgaSearchResults from '../../rga-search-results/state/rga-search-result';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import UsefulLinksPanel from '../../search/components/useful-links-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleOnMassUpdate() {

    this.actions.openMassUpdateModal();

}

function handleOnMassUpload() {

    this.actions.openMassUploadModal();

}
class MassUpdateRequestDetails extends Component {

    constructor(props) {

        super(props);
        this.state = {
            selectedMassUpdate: [...props.rgaSelectedMassUpdate]
        };

    }

    componentWillMount() {

        const updatedMassUpdate = this.state.selectedMassUpdate.map(rga => ({
            ...rga,
            analysisResult: '',
            failureDescription: '',
            findings: '',
            rgaNotes: '',
            supplierAnalysis: ''
        }));

        this.setState({selectedMassUpdate: updatedMassUpdate});

    }

    handleInputChange = (fieldName, event) => {

        const updatedMassUpdate = this.state.selectedMassUpdate.map(rga => ({
            ...rga,
            [fieldName]: event
        }));

        this.setState({selectedMassUpdate: updatedMassUpdate});

    };

    handleCancel = () => {

        this.props.actions.onSearchMassUpdate();

    }

    handleSave = () => {

        this.props.actions.updateMassUpdateRequest(this.state.selectedMassUpdate);

    }
    render() {

        return (
            <section className='mass-update'>

                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='rga-homepage-aside'>
                    <UsefulLinksPanel
                        onMassUpdate={this.props::handleOnMassUpdate}
                        onMassUpload={this.props::handleOnMassUpload}
                        security={this.props.security}
                    />
                </aside>
                <main className='rga-homepage-main'>
                    <div className='mass-update-rga-number'>
                        <h3>{'Selected RGA'}</h3>
                        <ul className='mass-update-rga-number-list'>
                            {this.props.rgaSelectedMassUpdate.map((rga, index) => (
                                <li key={index}>{rga.rgaNumber}</li>
                        ))}
                        </ul>
                    </div>
                    <div className='mass-update-row-panel'>
                        <div className='mass-update-row'>
                            <LabeledInput
                                className='mass-update-details'
                                isEditable={true}
                                label='Failure Description'
                                maxLength={5000}
                                onChange={this.handleInputChange.bind(this, 'failureDescription')}
                                tabIndex='1'
                                value={this.state.selectedMassUpdate[0].failureDescription || ''}
                            />
                        </div>
                        <div className='mass-update-row'>
                            <LabeledInput
                                className='mass-update-details'
                                isEditable={true}
                                label='Findings'
                                maxLength={5000}
                                onChange={this.handleInputChange.bind(this, 'findings')}
                                tabIndex='2'
                                value={this.state.selectedMassUpdate[0].findings || ''}
                            />
                        </div>
                        <div className='mass-update-row'>
                            <LabeledInput
                                className='mass-update-details'
                                isEditable={true}
                                label='Notes'
                                maxLength={5000}
                                onChange={this.handleInputChange.bind(this, 'rgaNotes')}
                                tabIndex='3'
                                value={this.state.selectedMassUpdate[0].rgaNotes || ''}
                            />
                        </div>
                        <div className='mass-update-row'>
                            <LabeledInput
                                className='mass-update-details'
                                isEditable={true}
                                label='Analysis Results'
                                maxLength={5000}
                                onChange={this.handleInputChange.bind(this, 'analysisResult')}
                                tabIndex='13'
                                value={this.state.selectedMassUpdate[0].analysisResult || ''}
                            />
                        </div>
                        <div className='mass-update-row'>
                            <LabeledInput
                                className='mass-update-details'
                                isEditable={true}
                                label='Supplier Analysis'
                                maxLength={5000}
                                onChange={this.handleInputChange.bind(this, 'supplierAnalysis')}
                                tabIndex='4'
                                value={this.state.selectedMassUpdate[0].supplierAnalysis || ''}
                            />
                        </div>

                        <section className='button-group'>
                            <button
                                className='secondary'
                                onClick={this.handleCancel.bind(this)}
                            >
                                <FormattedMessage id='Cancel'/>
                            </button>
                            <button
                                className='primary'
                                onClick={this.handleSave.bind(this)}
                            >
                                <FormattedMessage id='SAVE'/>
                            </button>
                        </section>
                    </div>
                </main>
            </section>
        );

    }
}

MassUpdateRequestDetails.displayName = 'MassUpdateRequestDetails';
MassUpdateRequestDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaSelectedMassUpdate: PropTypes.arrayOf(PropTypes.instanceOf(RgaSearchResults)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default MassUpdateRequestDetails;



// WEBPACK FOOTER //
// ./src/rga/mass-update/components/mass-update-request-details.js